import React from "react"

export const faq = [
  {
    title: "Gdzie mogę znaleźć cennik?",
    description: (
      <p>
        Do każdego klienta podchodzimy indywidualnie, nigdy nie mieliśmy
        sytuacji w której klienci mieli te same wymagania. Nie posiadamy więc
        stałego cennika. Odpowiadamy natomiast bardzo szybko na wysłane
        zapytania o wycenę. <a href="#contact">Wypełnij formularz</a>.
      </p>
    ),
  },
  {
    title: "Mam starą stronę internetową, czy opłaca się ją modernizować?",
    description: (
      <p>
        To zależy, musimy ją obejrzeć i przeanalizować aby odpowiedzieć na to
        pytanie. Przy witrynach które dawno nie były aktualizowane zwykle
        zalecamy zbudowanie nowej strony. W praktyce sytuacje bywają różne,
        dlatego zachęcamy do kontaktu.
      </p>
    ),
  },
  {
    title: "Co to jest CMS?",
    description: (
      <p>
        CMS to system zarządzania treścią. Za jego pomocą będziesz mógł w prosty
        sposób, np. dodać produkt do sklepu internetowego, albo zamieścić
        artykuł na swoim blogu. Prostota i przyjazny interfejs tego rozwiązania
        są zdecydowaną zaletą i ułatwieniem dla Ciebie.
      </p>
    ),
  },
  {
    title: "Czy drukujecie również banery, ulotki, itd?",
    description: (
      <p>
        Na Twoje życzenie jesteśmy w stanie zadbać o wysoki jakościowo wydruk z
        zaprzyjaźnionej drukarni. Działamy na terenie Katowic, Dzierżoniowa oraz
        Wrocławia. Dodatkowo po wcześniejszym ustaleniu możemy dostarczyć Twoje
        materiały pod wskazany przez Ciebie adres.
      </p>
    ),
  },
  {
    title: "Jaki jest czas realizacji strony internetowej?",
    description: (
      <p>
        Mniejsze strony internetowe udaje się nam zrealizować zwykle w terminie
        do 2 tygodni od momentu podpisania umowy i wpłacenia zaliczki.Przy
        większych i bardziej złożonych serwisach terminy ustalane są
        indywidualnie z klientem. Projekt dostarczany jest w zależności od
        wymagań i preferencji klienta - całościowo, bądź stopniowo przy
        wcześniej przeprowadzonych estymacjach czasowych i ustaleniu kolejnych
        kroków działań.
      </p>
    ),
  },
  {
    title: "Czy będę mógł zobaczyc statystyki swojej strony?",
    description: (
      <p>
        Na życzenie klienta integrujemy narzędzia takie jak Google Analytics
        które umożliwią ci obejrzenie statystyk strony. Ponadto pomożemy we
        wprowadzeniu strony do przeglądarki Google, tak aby możlwie było
        wyszukanie Twojej strony. Jeśli zdecydujesz się na serwis internetowy
        bądź sklep który będzie przyjmował wiele użytkowników, sugerujemy
        również skorzystanie z oprogramowania{" "}
        <a
          href="https://livesession.io/"
          target="_blank"
          rel="noopener noreferrer"
        >
          LiveSession
        </a>{" "}
        które pomoże Ci w analizie zachowania użytkowników na stronie, a tym
        samym zwiększenie sprzedaży bądź ruchu na stronie. Wszystkim się
        zajemiemy i pomożemy Ci jak najlepiej udostępnić stronę przyszłym
        klientom.
      </p>
    ),
  },
  {
    title: "Jaki będzie koszt utrzymania strony? Zapewniacie serwer?",
    description: (
      <p>
        Oczywiście, że tak. Jesteśmy w stanie zredukować koszt utrzymania Twojej
        nowej strony prawie do zera! Przeniesiemy Twoją stronę na serwery
        <a
          href="https://www.netlify.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Netlify
        </a>
        . Koszty serwera spadną do zera, a do opłacenia pozostanie Ci tylko
        roczny koszt domeny. Dodatkowo zyskasz darmowy certyfikat SSL, który
        poprawia zaufanie Twoich klientów do domeny. Pomoże to również w łatwym
        kontrolowaniu wersji twojej strony, wszelkie poprawki, powroty do
        poprzednich wersji będą zdecydowanie łatwiejsze i mniej kosztowne.
      </p>
    ),
  },
]
